import React, { useState } from 'react';
import { connect } from 'react-redux';
import { IonContent } from '@ionic/react';

import { screen } from '$fcomponents/hoc';
import { TableView2, Header } from '$gcomponents/widgets';

import { TERM_TABLE_CONFIG, TERM_TABLE } from './termTable';
import { IonPageWrapper } from './styles';
import FactoryModel from '$fbusiness/models/factory';
import CurrentStateModel from '$fbusiness/models/currentState';
import TermEditModal from './termEditModal';
import ItemActionModel from '$gbusiness/models/itemAction';
import { factoryActions } from '$fbusiness/redux/factory';
import { dialog } from '$gcomponents/reusables';
import { configs } from '$configs';
import { initialTerm } from '$fbusiness/models/term';
import FabButton from '$fcomponents/fabButton';
import { accessHide, getAccess, isAccessible } from '$fbusiness/helpers/util';

interface TermsScreenProps {
  factory: FactoryModel;
  currentState: CurrentStateModel;
  deleteTerm;
}

const TermsScreen: React.FC<TermsScreenProps> = ({ factory, deleteTerm, currentState }) => {
  const [term, setTerm] = useState<any>(null);
  const ACCESS = getAccess(currentState);

  if (!factory) return <IonPageWrapper />;
  const { terms } = factory;

  const onCloseModal = async () => {
    setTerm(null);
  };

  const itemActions: Array<ItemActionModel> = [
    {
      label: 'BUTTON.EDIT',
      eventName: 'editItem',
      disabled: () => !isAccessible(ACCESS.ACTION.SETTING.TERM.EDIT, currentState),
      onClick: setTerm,
    },
    {
      label: 'BUTTON.DELETE',
      eventName: 'deleteItem',
      disabled: () => !isAccessible(ACCESS.ACTION.SETTING.TERM.DELETE, currentState),
      onClick: (row) => {
        dialog.confirm({
          message: 'MESSAGE.DELETE_WARNING',
          onPress: async () => {
            await deleteTerm(row.id, configs.api.term, factoryActions.fetchTermsF);
          },
        });
      },
    },
  ];

  return (
    <IonPageWrapper>
      <Header title="SCREEN.TERMS.TITLE" />
      <IonContent>
        <TableView2
          data={terms}
          tableConfig={TERM_TABLE_CONFIG}
          TABLE={TERM_TABLE()}
          itemActions={itemActions}
        />
      </IonContent>
      <TermEditModal term={term} onClose={onCloseModal} />
      <FabButton
        onClick={() => setTerm(initialTerm)}
        className={accessHide(ACCESS.ACTION.SETTING.TERM.CREATE)}
      />
    </IonPageWrapper>
  );
};

const mapStateToProps = (state) => ({
  factory: state.factory.factory,
  resetOnRoute: true,
});

const mapDispatchToProps = {
  onHydrate: () => factoryActions.fetchTerms,
  deleteTerm: factoryActions.deleteObj,
};

const connected = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(TermsScreen));
